import { render, staticRenderFns } from "./ChatKebabOptions.vue?vue&type=template&id=10e0fa90&scoped=true"
import script from "./ChatKebabOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatKebabOptions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatKebabOptions.vue?vue&type=style&index=0&id=10e0fa90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e0fa90",
  null
  
)

export default component.exports